import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Badge, Dropdown, Modal, Button, Form, Spinner } from "react-bootstrap";
import { ShoppingBag, Edit2, More, Trash } from "iconsax-react";
import { format } from 'date-fns';
import MyApiClient from "../../../api-client/MyApiClient";
import { sports } from '../Util/enum';

const TesseramentiPlayer = (props) => {

    const tokenDetailsString = sessionStorage.getItem('userDetails');
    const currentClubId = tokenDetailsString ? JSON.parse(tokenDetailsString).localId : null;

    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tesseramenti, setTesseramenti] = useState([]);
    // Incrementato dopo modifica/cancellazione per ricaricare l'elenco
    const [ricarica, setRicarica] = useState(0);
    
    const [editDateEnd, setEditDateEnd] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            if (props.userId) {
                try {
                    setLoading(true);
                    const tokenDetailsString = sessionStorage.getItem('userDetails');
                    if (tokenDetailsString) {
                        const tokenDetails = JSON.parse(tokenDetailsString);
                        const token = tokenDetails.idToken;
                        const apiClient = new MyApiClient();

                        const response = await apiClient.getPlayerLicenses(token, props.userId);
                        if (response && Array.isArray(response)) {
                            // Map backend response if needed, for now assume it matches or has similar structure
                            // Adjust mapping based on actual backend response
                            setTesseramenti(response);
                        } else if (response && response.items) {
                            setTesseramenti(response.items);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching player licenses:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchData();
    }, [props.userId, ricarica]);

    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setShowDeleteModal(true);
    };

    const handleSaveEdit = async () => {
        if (!editDateEnd) {
            alert('Inserisci una data di scadenza valida');
            return;
        }

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                // Call the appropriate API endpoint to update the license
                const saveResult = await apiClient.updatePlayerLicense(token, selectedItem.id, props.userId, {
                    expiration: editDateEnd
                });

                if (saveResult && saveResult.error) {
                    alert("Si è verificato un errore durante il salvataggio: " + saveResult.error);
                } else {
                    // Refresh data
                    setShowEditModal(false);
                    setRicarica((n) => n + 1);
                }
            }
        } catch (error) {
            console.error("Error saving license:", error);
            alert("Errore durante il salvataggio");
        }
    };

    const handleConfirmDelete = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const deleteResult = await apiClient.deletePlayerLicense(token, selectedItem.id, props.userId);
                
                if (deleteResult && deleteResult.error) {
                    alert("Si è verificato un errore durante la cancellazione: " + deleteResult.error);
                } else {
                    setShowDeleteModal(false);
                    setRicarica((n) => n + 1);
                }
            }
        } catch (error) {
            console.error("Error deleting license:", error);
            alert("Errore durante la cancellazione");
        }
    };

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Tesseramenti</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table responsive className="dataTable">
                        <thead>
                            <tr>
                                <th>Sport</th>
                                <th>Ente</th>
                                <th>Validità</th>
                                <th>ASD/SSD</th>
                                <th>Origine</th>
                                <th>Stato</th>
                                {!props.readOnly && <th></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={props.readOnly ? "6" : "7"} className="text-center">
                                        <Spinner animation="border" variant="primary" />
                                    </td>
                                </tr>
                            ) : tesseramenti.length === 0 ? (
                                <tr>
                                    <td colSpan={props.readOnly ? "6" : "7"} className="text-center">Nessun tesseramento trovato</td>
                                </tr>
                            ) : tesseramenti.map((item, index) => (
                                <tr key={item.id || index}>
                                    <td>{sports.find(s => s.value === (item.sportType || item.sport))?.label || item.sportType || item.sport || '-'}</td>
                                    <td>{item.federationCode || item.federation || item.ente || item.organization || '-'}</td>
                                    <td>
                                        {item.dateStart ? format(new Date(item.dateStart), 'dd/MM/yyyy') : '-'}
                                        {' - '}
                                        {(item.expiration || item.dateEnd || item.endDate || item.expireDate) ? format(new Date(item.expiration || item.dateEnd || item.endDate || item.expireDate), 'dd/MM/yyyy') : '-'}
                                    </td>
                                    <td>{item.asdssdName || item.clubName || item.asdSsd || '-'}</td>
                                    <td>
                                        {(item.source === 'ORDER' || item.source === 'product' || item.origin === 'product') ? (
                                            <div className="d-flex align-items-center">
                                                <ShoppingBag size="16" className="text-primary me-2" variant="Bulk" />
                                                <div>
                                                    <span className="d-block text-black font-w500">Acquisto</span>
                                                    <span className="d-block fs-12 text-muted">Da un acquisto in struttura</span>
                                                </div>
                                            </div>
                                        ) : (item.source === 'USER') ? (
                                            <div className="d-flex align-items-center">
                                                <Edit2 size="16" className="text-info me-2" variant="Bulk" />
                                                <div>
                                                    <span className="d-block text-black font-w500">Utente</span>
                                                    <span className="d-block fs-12 text-muted">Inserita da utente in app</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex align-items-center">
                                                <Edit2 size="16" className="text-warning me-2" variant="Bulk" />
                                                <div>
                                                    <span className="d-block text-black font-w500">Manuale</span>
                                                    <span className="d-block fs-12 text-muted">Inserita da struttura</span>
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        <Badge className="sid-pill" bg={
                                            (item.verificationStatus === 'APPROVED' || item.status === 'Attivo' || item.status === 'ACTIVE' || item.status === 'VALID')
                                                ? 'success'
                                                : (item.verificationStatus === 'PENDING' || item.status === 'PENDING')
                                                    ? 'warning'
                                                    : 'danger'
                                        }>
                                            {item.verificationStatus === 'APPROVED' ? 'Approvato'
                                                : item.verificationStatus === 'PENDING' ? 'In attesa' 
                                                : item.verificationStatus === 'REJECTED' ? 'Rifiutato' 
                                                : item.status || item.verificationStatus || '-'}
                                        </Badge>
                                    </td>
                                    {!props.readOnly && (
                                    <td>
                                        {(1>2 && item.id && item.clubId === currentClubId && (item.source === 'MANUAL' || item.source === 'ORDER' || item.origin === 'manual' || item.origin === 'manual_user' || item.origin === 'product')) && (
                                            <Dropdown>
                                                <Dropdown.Toggle as="div" className="btn-link i-false" style={{ cursor: 'pointer' }}>
                                                    <More size="24" className="text-primary" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    {/*<Dropdown.Item onClick={() => handleEditClick(item)}>
                                                        <CalendarEdit size="18" className="me-2 text-warning" /> Modifica scadenza
                                                    </Dropdown.Item>*/}
                                                    <Dropdown.Item onClick={() => handleDeleteClick(item)} className="text-danger">
                                                        <Trash size="18" className="me-2" /> Elimina
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        )}
                                    </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Modal */}
            <Modal className="fade" show={showEditModal} centered>
                <Modal.Header>
                    <Modal.Title>Modifica tessera</Modal.Title>
                    <Button onClick={() => setShowEditModal(false)} variant="" className="btn-close"></Button>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col className="col-lg-12 pb-4">
                                <Form.Label>Data scadenza tessera</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    value={editDateEnd} 
                                    onChange={(e) => setEditDateEnd(e.target.value)} 
                                />
                            </Col>
                            {/*<Col className="col-lg-6 pb-4">
                                <Form.Label>ASD/SSD di tesseramento</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={editAsdSsd} 
                                    onChange={(e) => setEditAsdSsd(e.target.value)} 
                                />
                            </Col>*/}
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setShowEditModal(false)}>
                        Annulla
                    </Button>
                    <Button className="btn btn-primary btn-add" onClick={handleSaveEdit}>
                        Salva modifiche
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Elimina tesseramento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Sei sicuro di voler eliminare questo tesseramento manuale?
                    <br />
                    L'operazione è irreversibile.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary light" onClick={() => setShowDeleteModal(false)}>
                        Annulla
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDelete}>
                        Elimina
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default TesseramentiPlayer;